<template>
  <v-sheet outlined class="payment-monitoring-filters">
    <v-row dense align="center">
      <v-col cols="12" sm="6" :md="showStatusFilter ? 2 : 3">
        <v-select
          v-model="localValue.datePreset"
          :items="datePresets"
          item-text="text"
          item-value="id"
          label="Tarih aralığı"
          prepend-inner-icon="mdi-calendar-range"
          dense
          outlined
          hide-details="auto"
          @change="applyPreset"
        />
      </v-col>
      <v-col cols="12" sm="6" :md="showStatusFilter ? 2 : 3">
        <v-select
          v-model="localValue.paymentProviderIds"
          :items="paymentProviderList"
          item-text="name"
          item-value="id"
          label="Sağlayıcı"
          prepend-inner-icon="mdi-source-branch"
          multiple
          clearable
          dense
          outlined
          hide-details="auto"
        />
      </v-col>
      <v-col v-if="showStatusFilter" cols="12" sm="6" md="2">
        <v-select
          v-model="localValue.statuses"
          :items="statusItems"
          item-text="text"
          item-value="id"
          label="Durum"
          prepend-inner-icon="mdi-list-status"
          multiple
          clearable
          dense
          outlined
          hide-details="auto"
        />
      </v-col>
      <v-col v-if="showQuery" cols="12" sm="8" md="4">
        <v-text-field
          v-model.trim="localValue.query"
          :label="queryLabel"
          prepend-inner-icon="mdi-magnify"
          clearable
          dense
          outlined
          hide-details="auto"
          @keyup.enter="$emit('apply')"
        />
      </v-col>
      <v-col cols="12" sm="4" md="2" class="d-flex justify-end">
        <v-btn
          color="primary"
          block
          class="payment-monitoring-filter-button"
          :disabled="customDateRangeInvalid"
          @click="$emit('apply')"
        >
          <v-icon small left>mdi-filter</v-icon>
          Uygula
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="isCustomDateRange" dense>
      <v-col cols="12" sm="6" md="3">
        <v-text-field
          v-model="localValue.dateRange.min"
          type="date"
          label="Başlangıç tarihi"
          prepend-inner-icon="mdi-calendar"
          :max="localValue.dateRange.max"
          dense
          outlined
          hide-details="auto"
        />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-text-field
          v-model="localValue.dateRange.max"
          type="date"
          label="Bitiş tarihi"
          prepend-inner-icon="mdi-calendar"
          :min="localValue.dateRange.min"
          dense
          outlined
          hide-details="auto"
        />
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import { mapGetters } from "vuex";
import {
  PAYMENT_MONITORING_CUSTOM_DATE_PRESET,
  paymentMonitoringDatePresets,
} from "../paymentMonitoring";

export default {
  name: "PaymentMonitoringFilters",
  props: {
    value: {
      type: Object,
      required: true,
    },
    showQuery: {
      type: Boolean,
      default: true,
    },
    queryLabel: {
      type: String,
      default: "TYA ara",
    },
    statusItems: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters(["paymentProviderList"]),
    datePresets() {
      return [
        ...paymentMonitoringDatePresets(),
        {
          id: PAYMENT_MONITORING_CUSTOM_DATE_PRESET,
          text: "Özel Tarih Aralığı",
        },
      ];
    },
    isCustomDateRange() {
      return (
        this.localValue.datePreset === PAYMENT_MONITORING_CUSTOM_DATE_PRESET
      );
    },
    showStatusFilter() {
      return this.statusItems.length > 0;
    },
    customDateRangeInvalid() {
      if (!this.isCustomDateRange) {
        return false;
      }

      const { min, max } = this.localValue.dateRange || {};

      return !min || !max || min > max;
    },
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    applyPreset(id) {
      if (id === PAYMENT_MONITORING_CUSTOM_DATE_PRESET) {
        return;
      }

      const preset = this.datePresets.find((item) => item.id === id);

      if (preset) {
        this.$set(this.localValue, "dateRange", {
          min: preset.min,
          max: preset.max,
        });
      }
    },
  },
};
</script>

<style scoped>
.payment-monitoring-filters {
  margin-bottom: 18px;
  padding: 12px 14px;
  border-color: #e4e6ef !important;
  border-radius: 6px !important;
  background: #ffffff;
  box-shadow: 0 3px 12px rgba(29, 33, 68, 0.035);
}

.payment-monitoring-filter-button {
  min-height: 40px;
  border-radius: 4px;
  box-shadow: none;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.payment-monitoring-filters ::v-deep .v-input__slot {
  min-height: 40px !important;
  border-radius: 4px !important;
  background: #ffffff !important;
}

.payment-monitoring-filters ::v-deep .v-input__slot fieldset {
  border-color: #d8dbe6;
}

.payment-monitoring-filters ::v-deep .v-label,
.payment-monitoring-filters ::v-deep input,
.payment-monitoring-filters ::v-deep .v-select__selection {
  font-size: 12px;
  font-weight: 600;
}
</style>
